import { render, staticRenderFns } from "./ApprovedShiftsModal.vue?vue&type=template&id=f5dfa9c0&scoped=true"
import script from "./ApprovedShiftsModal.vue?vue&type=script&lang=js"
export * from "./ApprovedShiftsModal.vue?vue&type=script&lang=js"
import style0 from "./ApprovedShiftsModal.vue?vue&type=style&index=0&id=f5dfa9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dfa9c0",
  null
  
)

export default component.exports